module.exports = __webpack_public_path__ + "static/media/circular-std-black.ttf";